import { getCustomerHistory } from "../services/CustomerAPI";
import { CommonUtility } from "../../Services/CommonUtility";
import PolicyApi from "../services/PolicyAPI";
import * as constant from '../../shared/util/constant';

class CustomerAndPolicyHistoryService
{
    getHistory = async (customerId : string) => {
        var history =  await getCustomerHistory(customerId)
        return history.map((item) => {
            return {
              ...item,
              changedDate: CommonUtility.formateDateTime(item.changedDate as any, CommonUtility.DateTimeFormatWithSecond),
            };
          });
    }

    
    getPolicyHistory = async (customerId : string) => {
       var  polciAPI = new PolicyApi();
        var history =  await polciAPI.getPolicyHistory(customerId)
        return history.map((item) => {
            return {
              ...item,
              changedDate: CommonUtility.formateDateTime(item.changedDate as any, CommonUtility.DateTimeFormatWithSecond),
              newValue: (item.newValue === constant.DEFAULT_GUID || item.newValue === "Unknown") ? "" : item.newValue,
              oldValue: (item.oldValue === constant.DEFAULT_GUID || item.oldValue === "Unknown") ? "" : item.oldValue,
            };
          });         
    }
}
export default CustomerAndPolicyHistoryService;